import { BuildingModel } from '../../../models/building.model';
import { AmenityModel } from './amenity.model';
import { BuildingUnitsModel } from './reg-builidng-units.model';
import { RegistrationSummaryModel } from './registration-summary.model';
import { ApartmentInfoModel } from './apartment-info.model';
import { Document } from '../../../models/document.model';
import { CodeDescriptionModel } from 'src/app/models/code-description.model';

export class RegistrationModel {
    attachments: any;
    constructor() {
        this.building = new BuildingModel();
        this.buildingUnits = new BuildingUnitsModel();
        this.registrationSummary = new RegistrationSummaryModel();
    }
    // {transactionID} we will get API as soon as click on POST;
    transactionId: string;
    // {regStatusCode} we will get status like: submit, approved;
    // while we send the code but API will return CodeDescriptionModel;
    registrationStatus: CodeDescriptionModel;
    // like AO/AMD/NRA/PVA;
    // while we send the code but API will return CodeDescriptionModel;
    registrationType: CodeDescriptionModel;
    // incidentId as unique id;
    incidentId: string;
    // buiding being registered, building base model from application shared models
    building: BuildingModel = null;
    buildingUnits: BuildingUnitsModel = null;
    registrationSummary: RegistrationSummaryModel = null;
    buildingServices: AmenityModel[] = [];
    // List of Apartments Registered
    apartments: ApartmentInfoModel [] = []; // apartments
    // all the uploaded documents
    documents: Document[] = [];
    // reason for AO/AMD - code and description
    registrationForRevisionReason: CodeDescriptionModel;
    // reason for AO/AMD when they select reason as other.
    otherRegistrationForRevisionReason: string = null;
}
